import { render, staticRenderFns } from "./WingsEdit.vue?vue&type=template&id=9aca8fee&"
import script from "./WingsEdit.vue?vue&type=script&lang=js&"
export * from "./WingsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports